/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./terminal-highlight (ignored)
// module id = 3
// module chunks = 0 1